module.exports = __webpack_public_path__ + "static/media/hightlight-brs-tweet.c82c0360.png";